// client/src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LobbyJoin from '@features/lobby/views/LobbyJoin.jsx';
import LobbyCreate from '@features/lobby/views/LobbyCreate.jsx';
import Lobby from '@features/lobby/views/Lobby.jsx';
import Home from '@features/home/views/Home.jsx';
import QuestionGameView from "@features/GameQuestion/views/QuestionGameView.jsx";
import ImageGameView from "@features/GameImage/views/ImageGameView";
import ParticlesCanvas from './styles/ParticlesCanvas.jsx';
import { SettingsProvider, useSettings } from './context/SettingsContext';
import SettingsModal from '@components/SettingsModal';
import FPSCounter from '@components/FPSCounter';
import LobbyList from '@features/lobby/views/LobbyList.jsx';
import { lobbySocket, LobbySocketContext } from './api/socket.js';

function App() {
    const [showSettings, setShowSettings] = React.useState(false);
    return (
        <SettingsProvider>
            <SettingsControlledParticles />
            <FPSCounter />
            <HelpToggle />
            <SettingsToggle show={showSettings} setShow={setShowSettings} />
            <LobbySocketContext.Provider value={lobbySocket}>
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/create" element={<LobbyCreate />} />
                    <Route path="/join" element={<LobbyJoin />} />
                    <Route path="/lobby/:id" element={<Lobby />} />
                    <Route path="/game/quiz/:id" element={<QuestionGameView />} />
                    <Route path="/game/image/:id" element={<ImageGameView />} />
                    <Route path="/lobbies" element={<LobbyList />} />
                </Routes>
            </Router>
            </LobbySocketContext.Provider>
        </SettingsProvider>
    );
}

// Wrapper für Partikel
function SettingsControlledParticles() {
    const { settings } = useSettings();
    return settings.particlesEnabled ? <ParticlesCanvas /> : null;
}

function SettingsToggle({ show, setShow }) {
    return (
        <>
            <button
                onClick={() => setShow(true)}
                className="client-settings-button"
                title="Einstellungen"
            >
                &#9881;
            </button>
            {show && <SettingsModal onClose={() => setShow(false)} />}
        </>
    );
}

function HelpToggle() {
    const [showHelp, setShowHelp] = React.useState(false);

    return (
        <div className="help-wrapper">
            <button
                onClick={() => setShowHelp(!showHelp)}
                className="help-button"
                title="Hilfe"
            >
                &#63;
            </button>
            {showHelp && (
                <div className="help-tooltip">
                    <p>Willkommen beim Quiz-Game!</p>
                    <p>• Erstelle oder trete einer Lobby bei</p>
                    <p>• Chatte mit anderen Spielern</p>
                    <p>• Beantworte Fragen und sammle Punkte</p>
                    <button
                        className="help-close"
                        onClick={() => setShowHelp(false)}
                    >
                        ✕
                    </button>
                </div>
            )}
        </div>
    );
}

export default App;
